import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const LocalIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 23'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2352 0.151221C6.55048 0.782029 3.51611 3.54887 2.66196 7.053C1.49792 11.8239 4.31674 16.5268 9.03593 17.9952L11.0009 22.3683C11.3786 23.2088 12.6188 23.2106 12.9981 22.3711L14.961 18.0329C18.9097 16.8043 21.6053 13.2613 21.5998 9.2486C21.6168 3.50637 16.2381 -0.877188 10.2352 0.151221ZM10.2724 17.1196C10.1833 16.9212 10.006 16.7719 9.78962 16.7129C5.62969 15.5798 3.11003 11.5162 4.11899 7.3809C4.83698 4.43534 7.40207 2.09641 10.4979 1.56641C15.5791 0.695912 20.1188 4.39613 20.1035 9.24589C20.109 12.7344 17.7001 15.8003 14.2089 16.7503C13.9931 16.809 13.8161 16.9577 13.7266 17.1553L12.0015 20.9679L10.2724 17.1196ZM11.999 4.43862C13.601 4.43862 15.0768 5.16595 16.0132 6.37466C16.6538 7.19866 17.0059 8.19851 17.0059 9.2485C17.0059 11.9036 14.7632 14.0569 11.999 14.0569C9.23483 14.0569 6.99219 11.9036 6.99219 9.2485C6.99219 6.59127 9.23408 4.43862 11.999 4.43862ZM11.999 5.87612C10.0603 5.87612 8.48855 7.38533 8.48855 9.2485C8.48855 11.1095 10.0611 12.6194 11.999 12.6194C13.937 12.6194 15.5095 11.1095 15.5095 9.2485C15.5095 8.51134 15.2635 7.81259 14.8135 7.23387C14.156 6.38509 13.1232 5.87612 11.999 5.87612Z'
      />
    </svg>
  );
};
